import type { NewsItem } from "@/types";

export const news: NewsItem[] = [
  {
    id: "n1",
    title: "2025国庆档票房再创新高，多部国产大片亮眼收官",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20cinema%20hall%20with%20glowing%20warm%20lights%20and%20rows%20of%20empty%20red%20seats%2C%20cinematic%20atmosphere%2C%20deep%20navy%20and%20golden%20accent%20lighting%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=news-cover-01&orientation=landscape",
    excerpt: "今年国庆档总票房表现强劲，多部国产影片凭借扎实的口碑实现逆势上扬，为电影市场注入一剂强心针。",
    content: [
      "随着假期结束，2025年国庆档正式落下帷幕。据示范数据统计，今年国庆档总票房较去年同期实现明显增长，多部国产影片在口碑的推动下实现了持续的排片增长。",
      "其中，科幻题材影片《星海彼岸》凭借精良的制作与深刻的情感内核成为档期内最大黑马，上映首周便收获大量好评。业内观察者指出，观众对内容品质的要求正不断提高，单纯的营销已难以支撑长线的票房表现。",
      "此外，多部现实题材作品同样表现稳健，说明类型多元、内容扎实的创作方向正逐渐成为市场主流。多家院线负责人表示，下半年仍有多部备受期待的影片定档，市场有望延续当前的活跃态势。",
      "业内人士认为，国庆档的亮眼表现不仅体现了观众旺盛的观影需求，也反映出国产电影在工业化水平与叙事能力上的稳步提升。",
    ],
    author: "91电影编辑部",
    date: "2025-10-08",
    category: "资讯",
    tags: ["国庆档", "票房", "国产电影"],
    relatedMovieId: "m1",
  },
  {
    id: "n2",
    title: "深度影评：《星海彼岸》为何能触动每一位观众的心",
    cover: "https://readdy.ai/api/search-image?query=Abstract%20cosmic%20scene%20with%20a%20lone%20silhouette%20gazing%20at%20a%20vast%20starfield%2C%20deep%20navy%20and%20soft%20teal%20tones%2C%20minimal%20cinematic%20illustration%2C%20dramatic%20lighting%2C%20high%20detail%20editorial%20art&width=800&height=500&seq=news-cover-02&orientation=landscape",
    excerpt: "一部科幻外壳下包裹的深情之作。《星海彼岸》真正打动人的，不是特效，而是它对孤独与归途的思考。",
    content: [
      "当银幕上的星光缓缓亮起，《星海彼岸》并没有急着展示宏大的宇宙奇观，而是把镜头对准了一个孤独的人。这或许正是它区别于普通科幻片的地方。",
      "影片的核心并非技术奇观，而是一个简单却深刻的问题：当我们远离家园，究竟在寻找什么？导演陈默用大量留白与静默的镜头，让观众有足够的空间去感受角色内心的起伏。",
      "江屿这个角色之所以令人共鸣，是因为他的恐惧与坚持都极为真实。他不是无所不能的英雄，而是一个会迷茫、会想家的普通人。这种真实感让科幻的想象有了情感的落点。",
      "值得一提的是影片的配乐与摄影。极简的画面配合克制的音乐，反而营造出比喧嚣更震撼的力量。当结尾那束光缓缓亮起时，许多观众都红了眼眶。",
      "《星海彼岸》证明了一件事：最好的科幻，永远是关于人的故事。",
    ],
    author: "影评人 沈墨",
    date: "2025-10-05",
    category: "影评",
    tags: ["星海彼岸", "科幻", "影评"],
    relatedMovieId: "m1",
  },
  {
    id: "n3",
    title: "行业观察：流媒体与院线正在走向怎样的新关系",
    cover: "https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20comparing%20a%20cinema%20screen%20and%20a%20streaming%20device%2C%20cool%20blue%20grey%20and%20orange%20accent%20palette%2C%20flat%20geometric%20editorial%20style%2C%20clean%20neutral%20background%2C%20high%20detail&width=800&height=500&seq=news-cover-03&orientation=landscape",
    excerpt: "当越来越多的影片选择同步上线流媒体，院线与平台的边界正在被重新定义，行业格局也在悄然改变。",
    content: [
      "过去几年，流媒体平台的崛起深刻改变了电影的发行方式。越来越多的作品选择缩短院线窗口期，甚至同步登陆线上，这一变化引发了行业的广泛讨论。",
      "支持者认为，流媒体为中小成本影片提供了更广阔的展示空间，也让观众的观影选择更加自由。而院线的支持者则强调，大银幕带来的沉浸感与仪式感，是任何家庭设备都无法替代的。",
      "事实上，两者的关系或许并非零和博弈。越来越多的从业者开始探索融合模式：先通过院线建立口碑，再借助流媒体扩大影响力，形成互相促进的良性循环。",
      "无论格局如何变化，内容质量始终是决定成败的关键。观众愿意为什么样的电影买单，答案最终仍掌握在他们手中。",
    ],
    author: "行业观察员 林岸",
    date: "2025-09-28",
    category: "行业动态",
    tags: ["流媒体", "院线", "行业趋势"],
  },
  {
    id: "n4",
    title: "《深空回响》定档预告发布，硬核科幻再掀话题热潮",
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20interior%20with%20glowing%20holographic%20displays%2C%20cool%20indigo%20and%20silver%20palette%2C%20minimal%20sci-fi%20cinematic%20illustration%2C%20dramatic%20lighting%2C%20high%20detail&width=800&height=500&seq=news-cover-04&orientation=landscape",
    excerpt: "备受期待的科幻新作《深空回响》发布首支定档预告，硬核的科学设定与紧凑的悬念迅速引发影迷热议。",
    content: [
      "在刚刚结束的发布会上，科幻电影《深空回响》正式发布首支定档预告片。短短两分钟的预告中，恢弘的空间站景观与紧张的叙事节奏迅速点燃了观众的期待。",
      "导演Elena Frost在采访中透露，影片在科学设定上做了大量严谨的考据，团队甚至邀请了天体物理顾问参与剧本创作，力求让每一个细节都经得起推敲。",
      "从预告来看，《深空回响》在视觉呈现上延续了她一贯的冷峻美学，画面构图克制而富有张力。影片将于年底正式与观众见面，目前已成为不少影迷年度期待的焦点。",
    ],
    author: "91电影编辑部",
    date: "2025-09-22",
    category: "资讯",
    tags: ["深空回响", "定档", "科幻"],
    relatedMovieId: "m4",
  },
  {
    id: "n5",
    title: "影评：从《长安旧梦》看历史题材电影的新表达",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20city%20skyline%20at%20dusk%20with%20warm%20lantern%20glow%2C%20deep%20red%20and%20amber%20tones%2C%20minimal%20cinematic%20illustration%2C%20misty%20atmosphere%2C%20high%20detail%20editorial%20art&width=800&height=500&seq=news-cover-05&orientation=landscape",
    excerpt: "《长安旧梦》没有停留在对历史的复刻，而是用现代视角重新讲述了一个关于家国与情义的故事。",
    content: [
      "历史题材电影最难的，从来不是还原，而是如何让今天的人产生共鸣。《长安旧梦》在这件事上做出了值得称道的尝试。",
      "影片放弃了宏大而空洞的战争叙事，转而聚焦于两个小人物的命运交织。他们的选择与挣扎，恰恰映照出大时代下每一个普通人的处境。",
      "在视觉层面，影片的美术与服装考究而不堆砌，暖黄的灯笼光与深红的铠甲构成了极具辨识度的色调。这种克制的审美，让整部影片如同一幅会流动的画卷。",
      "虽然影片在叙事节奏上仍有改进空间，但它为历史题材的当代表达提供了一个有意义的方向。历史不该只是被仰望，更应该被理解。",
    ],
    author: "影评人 顾言",
    date: "2025-09-18",
    category: "影评",
    tags: ["长安旧梦", "历史片", "影评"],
    relatedMovieId: "m2",
  },
  {
    id: "n6",
    title: "多部影片宣布延长密钥，市场长线放映成常态",
    cover: "https://readdy.ai/api/search-image?query=Cinema%20marquee%20sign%20glowing%20at%20night%20with%20warm%20bulbs%2C%20retro%20cinematic%20atmosphere%2C%20deep%20navy%20and%20golden%20tones%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=news-cover-06&orientation=landscape",
    excerpt: "多部口碑佳作相继宣布延长放映周期，反映出市场对优质内容的信心以及观众持续的观影热情。",
    content: [
      "近期，多部表现优异的影片陆续宣布延长放映密钥，这意味着它们将在院线停留更长时间。这一现象在近年来逐渐成为常态。",
      "业内人士分析，长线放映的背后是口碑驱动的市场逻辑。一部影片只要内容过硬，就有可能在首周之后持续吸引观众走进影院。",
      "对于观众而言，这意味着他们有更充裕的时间去发现和欣赏好作品；对于片方而言，则是对优质内容的又一次肯定。",
    ],
    author: "91电影编辑部",
    date: "2025-09-12",
    category: "资讯",
    tags: ["密钥延期", "院线", "市场"],
  },
  {
    id: "n7",
    title: "技术前沿：虚拟制作正在改变电影工业流程",
    cover: "https://readdy.ai/api/search-image?query=Film%20set%20with%20a%20large%20LED%20volume%20screen%20displaying%20a%20digital%20landscape%2C%20cool%20grey%20and%20teal%20palette%2C%20minimal%20industrial%20cinematic%20photography%2C%20dramatic%20lighting%2C%20high%20detail&width=800&height=500&seq=news-cover-07&orientation=landscape",
    excerpt: "从LED虚拟影棚到实时渲染，虚拟制作技术正逐步渗透到电影拍摄环节，为创作者带来全新的可能性。",
    content: [
      "近年来，虚拟制作技术在全球电影工业中迅速普及。借助巨大的LED背景墙与实时渲染引擎，导演可以在拍摄现场直接看到接近成片的画面效果。",
      "相比传统的绿幕拍摄，虚拟制作大幅减少了后期合成的工作量，也让演员的表演更加自然——因为他们面对的，是真实存在的光影而非一片空白。",
      "当然，这项技术也带来了新的挑战，例如对前期筹备与团队协作的要求显著提高。但不可否认，它正在重新定义电影制作的边界。",
      "随着相关工具的成本逐步下降，虚拟制作有望从大制作的专属，逐渐走向更广泛的创作群体。",
    ],
    author: "行业观察员 林岸",
    date: "2025-09-05",
    category: "行业动态",
    tags: ["虚拟制作", "电影技术", "工业"],
  },
  {
    id: "n8",
    title: "《迷雾山庄》口碑发酵，悬疑类型迎来新一轮关注",
    cover: "https://readdy.ai/api/search-image?query=Old%20isolated%20mansion%20in%20heavy%20fog%20at%20night%20with%20a%20single%20lit%20window%2C%20cool%20grey%20blue%20and%20deep%20green%20tones%2C%20minimal%20moody%20cinematic%20illustration%2C%20high%20detail&width=800&height=500&seq=news-cover-08&orientation=landscape",
    excerpt: "凭借扎实的剧本与出色的氛围营造，《迷雾山庄》在观众中口口相传，带动悬疑类型片再度受到瞩目。",
    content: [
      "上映以来，《迷雾山庄》凭借层层反转的剧情与出色的氛围营造，在社交媒体上引发了大量讨论，口碑持续发酵。",
      "影迷们热衷于拆解影片中的每一个细节，从台词暗示到场景布置，讨论热度居高不下。这种互动式的观影体验，正是悬疑类型片独有的魅力。",
      "有评论认为，影片的成功再次证明，悬疑片的核心竞争力始终是剧本。只有逻辑自洽、反转合理的故事，才能真正留住观众。",
      "受此带动，接下来一段时间将有多部悬疑题材新作与观众见面，类型竞争一触即发。",
    ],
    author: "91电影编辑部",
    date: "2025-08-30",
    category: "资讯",
    tags: ["迷雾山庄", "悬疑", "口碑"],
    relatedMovieId: "m7",
  },
  {
    id: "n9",
    title: "影评：动作片如何拍出真正的“爽感”",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20abstract%20action%20background%20with%20streaking%20speed%20lines%20and%20orange%20sparks%2C%20cool%20steel%20blue%20and%20amber%20accents%2C%20minimal%20cinematic%20illustration%2C%20high%20detail%20editorial&width=800&height=500&seq=news-cover-09&orientation=landscape",
    excerpt: "好的动作片不只是打得好看，更在于让每一次冲突都服务于人物与故事，而不是单纯堆砌场面。",
    content: [
      "很多人以为动作片的成功取决于特效有多炫、打斗有多密，但真正优秀的作品，往往赢在叙事节奏与人物动机上。",
      "以近期的《极夜行动》为例，影片的动作场面并非为了炫技，而是紧密服务于剧情推进。每一次交火，都在揭示角色的处境与选择。",
      "此外，动作设计如果缺乏情感支撑，观众很快就会审美疲劳。只有当观众在意角色的命运时，一场打斗才真正具有张力。",
      "因此，动作片的“爽感”本质上来自叙事的精准与情感的积累，而非单纯的视觉轰炸。这或许是创作者们最值得思考的地方。",
    ],
    author: "影评人 顾言",
    date: "2025-08-24",
    category: "影评",
    tags: ["动作片", "极夜行动", "影评"],
    relatedMovieId: "m9",
  },
  {
    id: "n10",
    title: "经典重映：老电影为何总能在新时代焕发生机",
    cover: "https://readdy.ai/api/search-image?query=Vintage%20film%20reel%20and%20projector%20with%20warm%20beam%20of%20light%2C%20nostalgic%20sepia%20and%20amber%20tones%2C%20minimal%20cinematic%20illustration%2C%20soft%20dusty%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-10&orientation=landscape",
    excerpt: "越来越多的经典影片以修复版的形式重返大银幕，并意外收获了大量年轻观众，这背后有着怎样的原因？",
    content: [
      "近年来，经典影片的修复重映成为院线的一道独特风景。许多几十年前的老电影，以全新的画质重回银幕，票房表现甚至超出预期。",
      "令人意外的是，走进影院的观众中有相当一部分是年轻人。对他们而言，这些影片既是补课，也是一种新鲜的观影体验。",
      "分析认为，真正的好故事具有穿越时间的力量。技术会更新，审美会变化，但人性与情感的内核始终不变。",
      "经典重映的意义，不仅在于怀旧，更在于让不同年代的观众在同一部作品里相遇，完成一次跨越时空的对话。",
    ],
    author: "91电影编辑部",
    date: "2025-08-16",
    category: "行业动态",
    tags: ["经典重映", "修复版", "影院"],
  },
  {
    id: "n11",
    title: "《极夜行动》主创专访：零下三十度的真实拍摄",
    cover: "https://readdy.ai/api/search-image?query=Snowy%20polar%20landscape%20at%20night%20with%20faint%20aurora%20and%20a%20lone%20vehicle%20trail%2C%20cold%20steel%20blue%20and%20soft%20teal%20tones%2C%20minimal%20cinematic%20illustration%2C%20high%20detail&width=800&height=500&seq=news-cover-11&orientation=landscape",
    excerpt: "为了还原最真实的环境，主创团队远赴极地实景拍摄。他们分享了那些镜头背后不为人知的辛苦与坚持。",
    content: [
      "在采访中，《极夜行动》的导演程峰坦言，这部影片的拍摄过程远比想象中艰难。团队在极地环境中工作了近两个月，最低气温达到零下三十度。",
      "“很多设备在低温下直接罢工，演员的脸被冻得几乎没有表情，但这恰恰是表演最真实的状态。”程峰回忆道。",
      "主演雷铮则表示，实景拍摄让他对角色有了更深的理解。“当你在那样的环境里真的感到绝望时，角色的恐惧就不再是演的。”",
      "正是这份对真实的执着，让《极夜行动》在观众心中留下了远超一般商业片的质感与重量。",
    ],
    author: "91电影编辑部",
    date: "2025-08-08",
    category: "资讯",
    tags: ["极夜行动", "专访", "幕后"],
    relatedMovieId: "m9",
  },
  {
    id: "n12",
    title: "影评：小成本电影的突围之道在哪里",
    cover: "https://readdy.ai/api/search-image?query=Minimal%20creative%20illustration%20of%20a%20small%20glowing%20film%20clapperboard%20among%20large%20dark%20shapes%2C%20warm%20amber%20highlight%20and%20cool%20grey%20background%2C%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-12&orientation=landscape",
    excerpt: "在资本与流量之外，一批小成本作品依然凭借真诚与巧思赢得了观众，它们做对了什么？",
    content: [
      "在动辄数亿制作费的行业环境里，小成本电影似乎先天处于劣势。但每年，总有那么几部小制作，凭借口碑完成惊人的突围。",
      "它们共同的特点，是把有限的资源集中在最关键的地方——一个好剧本、一段真诚的情感、一个独特的视角。",
      "观众其实并不苛求大场面。当一部作品足够真诚，能够在某个瞬间触动人心，它就有被记住的可能。",
      "小成本电影的突围之道，或许并不在于与大制作正面竞争，而在于找到属于自己的表达方式，并把它做到极致。",
    ],
    author: "影评人 沈墨",
    date: "2025-07-30",
    category: "影评",
    tags: ["小成本", "独立电影", "影评"],
  },
];